import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./auth-guard.service";
import { PaginaNaoEncontradaComponent } from "./pagina-nao-encontrada/pagina-nao-encontrada/pagina-nao-encontrada.component";

const appRoutes: Routes = [
  {
    path: "",
    data: {},
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./laudos-pa/visualizar-laudo/modules/visualizar-laudo.module"
      ).then((m) => m.VisualizarLaudoModule),
  },
  {
    path: "videos/sp/:laudonumero",
    data: { path: "", name: "" },
    loadChildren: () =>
      import("./videos-detran/modules/videos-detran.module").then(
        (m) => m.VideosDetranModule
      ),
  },
  {
    path: "videos",
    data: {
      LaudoNumero: "laudonumero",
      key: "laudovistoriaid",
    },
    loadChildren: () =>
      import(
        "./laudos-pa/laudo-vistoria-processo-video-form/modules/laudo-vistoria-processo-video-form.module"
      ).then((m) => m.LaudoVistoriaProcessoVideoFormModule),
  },
  {
    path: "imagemoriginal",
    data: {
      LaudoVistoria: "laudovistoria",
      key: "laudovistoriaid",
    },
    loadChildren: () =>
      import(
        "./laudos-pa/visualizar-imagem-original/modules/visualizar-imagem-original.module"
      ).then((m) => m.VisualizarImagemOriginalModule),
  },
  {
    path: "laudosms",
    data: { name: "", fa: "" },
    children: [
      {
        path: "",
        data: { path: "", name: "" },
        loadChildren: () =>
          import(
            "./laudos-ms/visualizar-laudo-renavam-grid/modules/visualizar-laudos-renavam-grid.module"
          ).then((m) => m.VisualizarLaudosRenavamGridModule),
      },
    ],
  },
  {
    path: "laudos",
    data: { name: "", fa: "" },
    children: [
      {
        path: "",
        data: { path: "", name: "" },
        loadChildren: () =>
          import(
            "./laudos/visualizar-laudo/modules/visualizar-laudos.module"
          ).then((m) => m.VisualizarLaudosRenavamGridModule),
      },
    ],
  },
  {
    path: "nfse",
    data: { name: "", fa: "" },
    children: [
      {
        path: "",
        data: { path: "", name: "" },
        loadChildren: () =>
          import("./nfse/nfse-payload/modules/nfse-payload.module").then(
            (m) => m.NfsePayloadModule
          ),
      },
    ],
  },
  {
    path: "agendamentovistorias",
    data: { path: "", name: "" },
    loadChildren: () =>
      import(
        "./agendamento-vistorias/agendamento-form/modules/agendamento-form.module"
      ).then((m) => m.AgendamentoFormModule),
  },
  {
    path: "agendamentovistorias/go/:cnpj",
    data: { path: "", name: "" },
    loadChildren: () =>
      import(
        "./agendamento-vistorias/agendamento-go-form/modules/agendamento-go-form.module"
      ).then((m) => m.AgendamentoGOFormModule),
  },
  {
    path: "agendamentovistorias/mg/:cnpj",
    data: { path: "", name: "" },
    loadChildren: () =>
      import(
        "./agendamento-vistorias/agendamento-mg-form/modules/agendamento-mg.module"
      ).then((m) => m.AgendamentoMGModule),
  },
  {
    path: "agendamentovistorias/es/:cnpj",
    data: { path: "", name: "" },
    loadChildren: () =>
      import(
        "./agendamento-vistorias/agendamento-es-form/modules/agendamento-es-form.module"
      ).then((m) => m.AgendamentoESFormModule),
  },
  {
    path: "agendamentovistorias/mt/:cnpj",
    data: { path: "", name: "" },
    loadChildren: () =>
      import(
        "./agendamento-vistorias/agendamento-mt-form/modules/agendamento-mt-form.module"
      ).then((m) => m.AgendamentoMTFormModule),
  },

  //Caso nenhuma rota seja encontrada
  { path: "**", component: PaginaNaoEncontradaComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
